import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="project-filter" — constrains the Project
// combobox to only the projects belonging to the chosen customer, disabling
// it (including "Unassigned entry") until a customer is picked. Mirrors the
// mockup's Project combobox (disabled/scoped by the chosen Customer).
//
// #filter is triggered both by the customer's own change (see hidden_data
// on that combobox_field) and by "combobox:connect" bubbling up from any
// combobox in this scope (see the wrapping element's data-action) — the
// latter covers the initial page load, since Stimulus doesn't guarantee
// this controller's own connect() runs after the Project combobox's.
export default class extends Controller {
  static targets = ["customerHidden", "projectCombobox"]

  filter() {
    const customerId = this.customerHiddenTarget.value
    const combobox = this.application.getControllerForElementAndIdentifier(this.projectComboboxTarget, "combobox")
    if (!combobox) return

    combobox.setConstraint("customerId", customerId, customerId === "")
  }
}
